export default "__VITE_ASSET__DZ7KzG6b__"